<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">{{ total }}{{ $t("message.datagridresult") }}</div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @row-dblclick="handleDbClick">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="order" v-bind:label="$t('message.order')" width="80"></el-table-column>
                <el-table-column prop="title" :show-overflow-tooltip="true" label="Title" width="200"></el-table-column>
                <el-table-column prop="isEventGroup" label="Type" width="150"></el-table-column>
                <el-table-column prop="internetContentCode" :show-overflow-tooltip="true" v-bind:label="$t('message.eventId')" width="200"></el-table-column>
                <el-table-column prop="eventTypesName" v-bind:label="$t('message.Event Types')" width="100"></el-table-column>
                <el-table-column prop="eventGroupTypeName" label="Event Group Types" width="150"></el-table-column>
                <el-table-column prop="status" v-bind:label="$t('message.Status')" width="100"></el-table-column>
                <el-table-column prop="venue" v-bind:label="$t('message.venue')" width="100"></el-table-column>
                <el-table-column prop="startDate" v-bind:label="$t('message.Start Date')" width="130"></el-table-column>
                <el-table-column prop="endDate" v-bind:label="$t('message.End Date')" width="130"></el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
            <div class="col-sm-12 row" style="margin-top: -30px">
              <div class="pull-right">
                <button class="btn btn-white" @click="orderEvent" v-if="checkPermission('HIGHLIGHTS_LIST_UPDATE')">{{ $t("message.Rearrange Order") }}</button>
                <button class="btn btn-white" @click="addEvent" v-if="checkPermission('HIGHLIGHTS_LIST_NEW')">Add Event</button>
                <button class="btn btn-white" @click="addEventGroup">Add Event Group</button>
                <button class="btn btn-white" @click="showWarning" v-if="checkPermission('HIGHLIGHTS_LIST_DELETE')">{{ $t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      searchName: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "ASC",
      sortField: "id",
    };
  },
  created: function () {},
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = this.page;
      objdata.maxRows = this.pagesize;
      objdata.apiUrl = "/getHighlightsEventList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      let list = null;
      for (list of data.data.resultList) {
        list.isEventGroup = list.isEventGroup ? "Event Group" : "Indiviual Event";
        if (list.status === 0) {
          list.status = this.$i18n.t("message.Draft");
        } else if (list.status == 10) {
          list.status = this.$i18n.t("message.Publish");
        } else if (list.status == 1) {
          list.status = this.$i18n.t("message.Unpublish");
        } else if (list.status == 2) {
          list.status = "Expired";
        }

        if (list.eventTypes === 1) {
          list.eventTypesName = "Performing Arts";
        } else if (list.eventTypes == 2) {
          list.eventTypesName = "Exhibitions";
        } else if (list.eventTypes == 3) {
          list.eventTypesName = "Talks / Forums";
        } else if (list.eventTypes == 4) {
          list.eventTypesName = "Guided Tour";
        } else if (list.eventTypes == 5) {
          list.eventTypesName = "Workshops";
        } else if (list.eventTypes == 6) {
          list.eventTypesName = "Screening";
        } else if (list.eventTypes == 7) {
          list.eventTypesName = "Festival";
        } else if (list.eventTypes == 9) {
          list.eventTypesName = "Other";
        }
        if (list.eventGroupType === 1) {
          list.eventGroupTypeName = this.$i18n.t("message.Series");
        } else if (list.eventGroupType == 2) {
          list.eventGroupTypeName = this.$i18n.t("message.Package");
        } else if (list.eventGroupType == 3) {
          list.eventGroupTypeName = this.$i18n.t("message.Festival");
        }
      }
      this.rows = data.data.resultList;
      this.total = data.data.totalRows;
      this.getVenueList();
    },
    async getVenueList() {
      let objdata = this.getAuthObj();
      objdata.sortField = "id";
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.status = 1;
      objdata.apiUrl = "/getVenueList";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      this.venueList = data.data.resultList;
      this.venueObj = [];
      for (var i = 0; i < this.venueList.length; i++) {
        this.venueObj.push({
          value: this.venueList[i].id + "",
          label: this.getObject(this.venueList[i].langMap, this.langKey[0]).content,
        });
      }

      let list = null;
      for (list of this.rows) {
        if (list.venue) {
          list.venue = list.venue.split(",");
          var str = [];
          list.venue.forEach(item => {
            this.venueObj.forEach(obj => {
              if (item == obj.value) {
                str.push(obj.label);
              }
            });
          });
          list.venue = str.join(", ");
        }
      }
    },
    addEvent() {
      var that = this;
      this.$store.commit("seteventlist", {
        callback: function (item) {
          that.$store.commit("seteventlist", { string: "", boolean: false });
          that.createHighlights(item);
        },
        boolean: true,
        button: [],
      });
    },
    addEventGroup() {
      var that = this;
      this.$store.commit("seteventgrouplist", {
        callback: function (item) {
          that.$store.commit("seteventgrouplist", { string: "", boolean: false });
          that.createHighlights(item);
        },
        boolean: true,
        button: [],
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 0;
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.multipleSelection.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    async updateHighlights(item) {
      let ids = [];
      let objdata = this.getAuthObj();
      if (item.length != 0) {
        for (let i = 0; i < item.length; i++) {
          ids.push(item[i].eventId);
        }
      }
      objdata.eventIds = ids;

      objdata.apiUrl = "/updateHighlightsEvent";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.init();
      }
    },
    async createHighlights(item) {
      let ids = [];
      let objdata = this.getAuthObj();
      if (item.length != 0) {
        for (let i = 0; i < item.length; i++) {
          ids.push(item[i].id);
        }
      }
      objdata.eventIds = ids;

      objdata.apiUrl = "/createHighlightsEvent";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.init();
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids;

      objdata.apiUrl = "/deleteHighlightsEvent";
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange: function (val) {
      this.page = val - 1;
      this.init();
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    sortChange: function (val) {
      if (val.order == "ascending") {
        this.sortType = "ASC";
        this.sortField = val.prop;
      } else if (val.order == "descending") {
        this.sortType = "DESC";
        this.sortField = val.prop;
      } else {
        this.sortType = "ASC";
        this.sortField = "id";
      }
      this.init();
    },
    orderEvent: function () {
      var that = this;
      this.$store.commit("setordereventlist", {
        callback: function (item) {
          that.$store.commit("setordereventlist", { string: "", boolean: false });
          that.updateHighlights(item);
        },
        boolean: true,
        button: [],
      });
    },
    handleDbClick: function (row) {
      if (row.isEventGroup == "Event Group") {
        this.$router.push({
          path: "/main/eventGroupDetailHighLight",
          query: {
            id: row.eventId,
            type: row.eventGroupType,
          },
        });
      } else {
        this.$router.push({
          path: "/main/eventDetailHighLight",
          query: {
            id: row.eventId,
            type: row.eventTypes,
          },
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.ui-grid-icon-ok:before {
  content: "\c362";
}
.ui-grid-icon:before,
.ui-grid-icon:before {
  font-family: "ui-grid";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: 0.2em;
}
</style>
